import { UserGroupIcon } from '@heroicons/react/24/outline';
import env from '../../../environment';
import type { FeaturePageDataInterface } from './types';

export const shareWithEmployees: FeaturePageDataInterface = {
  slug: 'share-with-employees',
  navTitle: 'Share with your research team',
  shortTitle: 'Team access',
  navDescription:
    'Invite teammates to shared crawl projects — discovery, extraction, and prospect capture in one place.',
  Icon: UserGroupIcon,
  headline: 'Share crawl projects with',
  highlight: 'your whole team',
  blurb:
    'Research work usually scatters across personal scrapers and spreadsheets. Stark Crawl keeps discovery, crawling, and prospect capture in shared projects your team can use together.',
  quote: {
    text: 'We invited the research pod the same day. Hosts, schemas, and exports stopped living on one person’s laptop.',
    author: 'Customer name',
    authorRole: 'Job title, Company',
  },
  image: {
    src: '/images/shots/team-access.png',
    alt: 'Stark Crawl access controls for sharing a crawl project with a research team',
  },
  content: [
    {
      type: 'block',
      body: {
        heading: 'Shared projects, clear roles',
        body: [
          'Invite analysts and operators to the same crawl project. Review host coverage together, refine schemas, and export prospect lists without emailing CSV dumps around.',
          'Domain access and invites keep the workspace with your team — not a public scrape dump on a shared drive.',
        ],
        large: true,
      },
    },
    {
      type: 'block',
      body: {
        heading: 'No scrape farm to hand over',
        body: [
          'When research lives in scrapers on one machine, onboarding is a knowledge transfer project. Shared Stark Crawl projects mean a colleague opens the project and sees the same hosts, runs, and captures.',
          'That makes rollout a message in the team channel, not an engineering handoff.',
        ],
      },
    },
    {
      type: 'block',
      body: {
        heading: 'Separate projects when the work differs',
        body: [
          'Need different audiences for different markets? Run separate projects per vertical or region, each with its own hosts, schema, and access list.',
          'Category research, competitor monitoring, and prospect capture stay organised without mixing scopes.',
        ],
      },
    },
    {
      type: 'solution',
      body: 'Invite your research team to a shared crawl project — discovery, extraction, and export in one place.',
      cta: 'Try for free',
      url: env.appUrl + '/register',
    },
  ],
  seo: {
    title: 'Share crawl projects with your research team - Stark Crawl',
    description:
      'Invite teammates to shared crawl projects — discovery, extraction, and prospect capture in one workspace.',
    keywords:
      'team crawl projects, research collaboration, shared prospect capture, Stark Crawl',
  },
  ctaTitle: 'Your whole team, in minutes',
  ctaBody:
    'Invite analysts and operators to shared crawl projects — hosts, schemas, and exports in one workspace.',
};
